import { Colors } from "components/utils";

export const getAwaitingLabelColor = (daysLeftToDelivery: number): Colors => {
  if (daysLeftToDelivery >= 1) {
    return "transparent-blue";
  } else {
    return "transparent-orange";
  }
};
